import { resultsetWithFields, initChart, initElement } from 'vlcishared';
import { optionIntervencionesTipo } from './options-charts';
import { TEXTS_SEGURIDAD_DETAIL } from './texts';
import { DEFAULT_LANGUAGE } from '../common-language';

export function echartIntervencionesTipo(datos) {
  const chartOptions = JSON.parse(JSON.stringify(optionIntervencionesTipo));
  chartOptions.series[0].label.formatter =
    optionIntervencionesTipo.series[0].label.formatter;
  chartOptions.tooltip.formatter = optionIntervencionesTipo.tooltip.formatter;
  const resultSet = resultsetWithFields(datos);
  chartOptions.series[0].data = [];
  resultSet.forEach((row) => {
    chartOptions.series[0].data.push({
      value: row.total_intervenciones,
      name: row.agrupacion || 'N/D',
      porcentage: row.porcentaje_total,
    });
  });
  initChart('chart_IntervencionesTipo', chartOptions);
}

export function updateTipologia() {
  const tipologia = Dashboards.getParameterValue('filterParamTipo');
  let subtext = '';
  if (tipologia == 'All') {
    subtext = TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('tipologia_nivel_1');
  } else {
    subtext = TEXTS_SEGURIDAD_DETAIL[DEFAULT_LANGUAGE].get('tipologia_nivel_2');
  }
  const initLastUpdate = async (element) => {
    const chartInstance = await echarts.getInstanceByDom(element);
    chartInstance.setOption(
      {
        title: {
          subtext: subtext,
        },
      }
    );
  };
  initElement('chart_IntervencionesTipo', initLastUpdate);
}
